/**
 * A global namespace for `Enter` key.
 * e.which = 13 equivalent
 */
const keyNumpadEnter = 'NumpadEnter';

export default keyNumpadEnter;
